import { BroadcastChannel } from 'broadcast-channel';

export const YandexHandler = () => {
  const searchQuery = window.location.hash.replace('#', '?');
  const searchParams = new URLSearchParams(searchQuery);
  const token = searchParams.get('access_token');
  const expiresIn = searchParams.get('expires_in');
  const chanel = new BroadcastChannel('auth-yandex-code');

  if (token) {
    chanel.postMessage({
      access_token: token,
      expires_in: expiresIn,
      success: true,
    });
  } else {
    const error = {};
    searchParams.forEach((value, key) => {
      error[key] = value;
    });
    chanel.postMessage({
      success: false,
      error,
    });
  }
  setTimeout(() => {
    window.close();
  }, 250);
};
